import { convertDate } from 'modules/core/lib/dates'

export enum PeriodType {
  by_time_range = 'by_time_range',
  by_contract_start_date = 'by_contract_start_date',
}

export enum DurationUnit {
  days = 'days',
  months = 'months',
}

export interface ITimePeriod {
  id?: number
  name: string
  periodType: PeriodType
  duration?: number
  durationUnit?: DurationUnit
  startOn?: string
  finishOn?: string
  _destroy?: boolean
}

class TimePeriod {
  id?: number
  name: string
  periodType: PeriodType
  duration?: number
  durationUnit?: DurationUnit
  startOn?: string
  finishOn?: string

  constructor({ id, name, periodType, duration, durationUnit, startOn, finishOn }: ITimePeriod) {
    this.id = id
    this.name = name
    this.periodType = periodType
    this.duration = duration
    this.durationUnit = durationUnit
    this.startOn = startOn
    this.finishOn = finishOn
  }

  get byTimeRange(): boolean {
    return this.periodType === PeriodType.by_time_range
  }

  get byContractStartDate(): boolean {
    return this.periodType === PeriodType.by_contract_start_date
  }

  get durationInDays(): boolean {
    return this.durationUnit == DurationUnit.days
  }

  get durationInMonths(): boolean {
    return this.durationUnit == DurationUnit.months
  }

  get formattedStartOn(): string {
    return this.startOn ? convertDate(this.startOn, 'backend', 'ui') : ''
  }

  get formattedFinishOn(): string {
    return this.finishOn ? convertDate(this.finishOn, 'backend', 'ui') : ''
  }

  static PeriodType = PeriodType
}

export default TimePeriod
